import React from 'react';
import PropTypes from 'prop-types';
import {
  DatePicker, Form, Input, InputNumber
} from 'antd';
import moment from 'moment';
import ReportWrapper from 'components/Reports';
import { FormWrapper } from 'components/Page';
import RosterReportInputs from 'views/reports/RosterReportInputs';
import Item from './Item';

const mapPropsToFields = (props) => {
  const { dataSource } = props;
  const { ...rest } = dataSource;
  const restKeys = Object.keys(rest);
  const dynamicFields = {};
  for (let i = 0; i < restKeys.length; i++) {
    const potentialFieldValue = rest[restKeys[i]];
    if (typeof potentialFieldValue !== 'object') {
      dynamicFields[restKeys[i]] = Form.createFormField({ value: potentialFieldValue });
    }
  }
  return {
    ...dynamicFields
  };
};
const onFieldsChange = (props, fields) => {
  const { onFieldsChange: fieldsChange } = props;
  if (fieldsChange) {
    fieldsChange(fields);
  }
};

const onValuesChange = (props, values) => {
  const { onValuesChange: valuesChange } = props;
  if (valuesChange) {
    valuesChange(values);
  }
};

const getInitialValue = (param_type_name) => {
  switch (param_type_name) {
  case 'Integer':
    return 0;
  case 'Date':
    return moment();
  default:
    return '';
  }
};
const getElement = (param_type_name) => {
  switch (param_type_name) {
    case 'Integer':
      return <InputNumber min={0} />;
    case 'Date':
      return <DatePicker showTime={false} format="DD-MM-YYYY" />;
      default:
      return <Input />;
  }
};

const getFormItems = (form, inputFormItemLayout, report, dataSource) => {
  const { getFieldDecorator } = form;
  const { parameters, id: reportId } = report;
  switch (reportId) {
  case 6:
    return (<RosterReportInputs form={form} />);
  default:
    return parameters.map((parameter) => {
      const {
        id, name, param_type_name, display_name
      } = parameter;
      const initialValue = dataSource[name] === undefined ? getInitialValue(param_type_name) : dataSource[name];
      return (
        <Item display_name={display_name} key={id} inputFormItemLayout={inputFormItemLayout}>
          {
            getFieldDecorator(name, {
              initialValue
            })(getElement(param_type_name))
          }
        </Item>
      );
    });
  }
};

const FormInput = ({
  form, inputFormItemLayout, report, dataSource
}) => (
  <Form layout="inline" style={{ maxWidth: 'unset' }}>
    {getFormItems(form, inputFormItemLayout, report, dataSource)}
  </Form>
);

FormInput.propTypes = {
  form: PropTypes.object,
  dataSource: PropTypes.object,
  report: PropTypes.object.isRequired,
  inputFormItemLayout: PropTypes.object
};

FormInput.defaultProps = {
  form: {},
  dataSource: {},
  inputFormItemLayout: {}
};

const ReportInput = ReportWrapper(FormWrapper(Form.create({
  mapPropsToFields,
  onFieldsChange,
  onValuesChange
})(FormInput)));

export default ReportInput;
